import React from 'react';

export default function ApprovalDisbursement() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Approval Disbursement</h1>
      <p className="text-gray-500">Halaman Approval Disbursement</p>
    </div>
  );
}
